import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { useCallback as _ } from "react";
import { Button as f, IconButton as p } from "../../../atoms/Button/Button.es.js";
import { ThemeMode as m } from "../../../atoms/ThemeMode/ThemeMode.es.js";
import { useToast as C, useMultiStyleConfig as g, useColorModeValue as b, chakra as s } from "@chakra-ui/react";
import { OldCloseIcon as x } from "../../../icons/index.es.js";
const j = ({
  action: t,
  description: r,
  id: i,
  isCloseable: h = !0,
  isInline: n = !0,
  size: u,
  variant: l = "default"
}) => {
  const c = C(), o = g("SnackbarTheme", { size: u, variant: l }), k = _(() => c.close(i), [i, c]), a = b("light", "dark");
  return /* @__PURE__ */ d(s.div, { __css: o.container, children: [
    /* @__PURE__ */ d(s.div, { __css: o.content, "data-inline": n, children: [
      /* @__PURE__ */ e(s.div, { __css: o.description, children: r && /* @__PURE__ */ e(s.p, { __css: o.description, children: r }) }),
      t && /* @__PURE__ */ e(m, { mode: l === "default" ? a === "dark" ? "light" : "dark" : "light", children: /* @__PURE__ */ e(f, { size: "sm", onClick: t.onClick, __css: o.actionButton, children: t.label }) })
    ] }),
    h && /* @__PURE__ */ e(m, { mode: l === "default" ? a === "dark" ? "light" : "dark" : "light", children: /* @__PURE__ */ e(s.div, { __css: o.close, "data-inline": n, children: /* @__PURE__ */ e(
      p,
      {
        "aria-label": "Close snackbar",
        icon: /* @__PURE__ */ e(x, {}),
        onClick: k,
        size: "sm",
        variant: "transparent",
        sx: {
          display: "flex"
        }
      }
    ) }) })
  ] });
};
export {
  j as SnackbarMessage
};
//# sourceMappingURL=useSnackbarMessage.es.js.map
